import React, { useMemo } from "react";
import DocumentCard from "components/card/DocumentCard";
import { FileCheck } from "lucide-react";
import NoDocument from "./NoDocument";

const ContractsDocument = ({ documents = [] }) => {
    const contractDocs = useMemo(() => {
        return documents.filter(doc => 
            doc.doc_type_name === 'Contract'
        );
    }, [documents]);

    if (contractDocs.length === 0) {
        return (
            <>
                <NoDocument docType="Contract"/>
            </>
        );
    }

    return (
        <div className="space-y-3">
            {contractDocs.map((doc) => (
                <DocumentCard
                    key={doc.doc_id}
                    title={doc.doc_title}
                    description={doc.doc_description}
                    status={doc.doc_status_name}
                    date={doc.doc_date}
                    size={doc.doc_size}
                    icon={<FileCheck className="w-5 h-5 text-blue-600" />}
                    documentData={doc}
                    onDownload={() => console.log(`Download ${doc.title}`)}
                />
            ))}
        </div>
    );
};

export default ContractsDocument;
